export default __webpack_public_path__ + "static/media/bb-hivebox-callouts.40e3ec0f.svg";